$(document).ready(function () {
  let isLoading = false;
  const LAMBDA_URL = 'https://5q332hommgpuhbtvh6unf3wjtm0hvmlz.lambda-url.ap-northeast-1.on.aws/';

  // Capacity check button clicked
  $('.capacity_input_btn').click(async function () {
    if (isLoading) return;

    const $button = $('.capacity_input_btn');
    const $input = $('#capacity_input_imei_value');
    const $error = $('#capacity_input_btn_error_message');

    const showError = (msg) => {
      $input.addClass('capacity_input_imei_value_error');
      $error.append(`<p><i class="fa fa-exclamation-triangle"></i>${msg}</p>`);
    };

    try {
      isLoading = true;

      $input.removeClass('capacity_input_imei_value_error');
      $('#capacity_input_btn_error_message p').remove();

      $button.prop('disabled', true);
      $button.empty();
      $button.append('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

      const imeiValue = $.trim($input.val());

      // Input validation
      if (!/^\d{13}$/.test(imeiValue)) {
        showError('Please enter a 13-digit number.');
        return;
      }

      // Reset table display
      $('.total-capacity-gb-display').text('-GB/-GB');
      $('#usa-tab-pane tbody.responsive-table__body').empty();
      $('#overseas-tab-pane tbody.responsive-table__body').empty();
      $('#overseas-tab2-pane tbody.responsive-table__body').empty();
      $('#usa-tab-pane .progress-bar').css('width', '0%');
      $('#usa-tab-pane .progress').attr('aria-valuenow', '0');

      const response = await fetch(`${LAMBDA_URL}?sn=${encodeURIComponent(imeiValue)}`);

      let capacityResult = null;
      try {
        capacityResult = await response.json();
      } catch (jsonError) {
        capacityResult = null;
      }

      // SN not found
      if (response.status === 404 || capacityResult?.error?.code === 'SN_NOT_FOUND') {
        showError('The serial number (SN) could not be found. Please check and try again.');
        return;
      }

      // Rate limited
      if (response.status === 429 || capacityResult?.error?.code === 'RATE_LIMITED') {
        showError('Too many requests. Please wait a moment and try again.');
        return;
      }

      // Any other failure (HTTP error, ok:false, empty body, etc.)
      if (!response.ok || !capacityResult || capacityResult.ok !== true) {
        showError(capacityResult?.error?.message || 'Failed to check data balance. Please try again later.');
        return;
      }

      let usaTotalCapacity = 0;
      let usaTotalRemainingCapacity = 0;

      (capacityResult.usaCapacityList || []).forEach((capacity) => {
        usaTotalCapacity += Number(capacity.dataTotal || 0);
        usaTotalRemainingCapacity += Number(capacity.surplusFlowbyte || 0) * 100;
        const planNameDisplay = capacity.plan ?? '';

        $("#usa-tab-pane tbody.responsive-table__body").append(`
          <tr class="responsive-table__row">
            <td class="responsive-table__body__text responsive-table__body__text--name">
              <span class="status-indicator ${
                capacity.status === 'INUSE'
                  ? 'status-indicator--active'
                  : 'status-indicator--inactive'
              }"></span>${capacity.countryName}
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">
              ${capacity.surplusFlowbyte}GB
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--plan">
              ${planNameDisplay}
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--effective-date">
              ${capacity.effectiveDate}
            </td>
          </tr>
        `);
      });

      (capacityResult.overseasCapacityList || []).forEach((capacity) => {
        const planNameDisplay = capacity.plan ?? '';

        $("#overseas-tab2-pane tbody.responsive-table__body").append(`
          <tr class="responsive-table__row">
            <td class="responsive-table__body__text responsive-table__body__text--name">
              <span class="status-indicator ${
                capacity.status === 'INUSE'
                  ? 'status-indicator--active'
                  : 'status-indicator--inactive'
              }"></span>${capacity.countryName}
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">
              ${capacity.surplusFlowbyte}GB
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--plan">
              ${planNameDisplay}
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--effective-date">
              ${capacity.effectiveDate}
            </td>
          </tr>
        `);
      });

      (capacityResult.capacityUsedList || []).forEach((capacity) => {
        const planNameDisplay = capacity.plan ?? '';
        $("#overseas-tab-pane tbody.responsive-table__body").append(`
          <tr class="responsive-table__row">
            <td class="responsive-table__body__text responsive-table__body__text--name">
              ${capacity.countryName}
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--plan">
              ${planNameDisplay}
            </td>
            <td class="responsive-table__body__text responsive-table__body__text--effective-date">
              ${capacity.effectiveDate}
            </td>
          </tr>
        `);
      });

      $('.total-capacity-gb-display').text(
        `${usaTotalRemainingCapacity / 100}GB/${usaTotalCapacity}GB`
      );

      const remainingCapacityRate =
        usaTotalCapacity > 0
          ? Math.round(((usaTotalRemainingCapacity / 100) / usaTotalCapacity) * 100)
          : 0;

      $('#usa-tab-pane .progress-bar').css('width', `${remainingCapacityRate}%`);
      $('#usa-tab-pane .progress').attr('aria-valuenow', remainingCapacityRate);
    } catch (error) {
      console.error('capacity-check-us error', error);
      showError('A network error occurred. Please try again later.');
    } finally {
      isLoading = false;
      $button.empty();
      $button.prop('disabled', false);
      $button.text('Check');
    }
  });

  $("#capacity_input_imei_value").on("blur", function () {
    check_imei_textbox($(this).val());
  });
});

function check_imei_textbox(str) {
  $('#capacity_input_imei_value').removeClass('capacity_input_imei_value_error');
  $("#capacity_input_btn_error_message p").remove();
  $("#capacity_check_error_textbox p").remove();

  const textbox = $.trim(str);

  if (!/^\d{13}$/.test(textbox)) {
    $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
    $("#capacity_input_btn_error_message").append(
      '<p><i class="fa fa-exclamation-triangle"></i>Please enter a 13-digit number.</p>'
    );
    return false;
  }

  return true;
}
